const copyToClipboard = function (text) {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text).then(() => {
      if (this.$toasted) {
        this.$toasted.success('Text copied to clipboard')
      }
    }).catch(err => {
      console.log(err)
      if (this.$toasted) {
        this.$toasted.error('Failed to copy text')
      }
    })
  } else {
    const textarea = document.createElement("textarea")
    textarea.value = text
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand("copy")
    document.body.removeChild(textarea)
    if (this.$toasted) {
      this.$toasted.success('Text copied to clipboard')
    }
  }
}

export default {
  copyToClipboard
}